import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { useBundle, useLocalizationContext } from '@amzn/react-arb-tools';
import SignupPage from './components/SignupPage';
import LoginPage from './components/LoginPage';
import ErrorPage from './components/ErrorPage';
import ChangePasswordPage from './components/ChangePasswordPage';
import { BUNDLE_NAME, LOCALE_QUERY_PARAM, getLocalizationContext, syncLocaleCookie } from './translationHelper';
import './css/App.css';

// Owns the runtime locale: applies a ?locale= override from the URL
function LocaleController() {
    const { search } = useLocation();
    const { localizationContext, setLocalizationContext } = useLocalizationContext();

    useEffect(() => {
        const locale = new URLSearchParams(search).get(LOCALE_QUERY_PARAM);
        if (!locale) {
            return;
        }

        const newLocaleContext = getLocalizationContext(locale);
        if (newLocaleContext.getLocale() !== localizationContext.getLocale()) {
            setLocalizationContext(newLocaleContext);
            syncLocaleCookie(newLocaleContext);
        }
    }, [search, localizationContext, setLocalizationContext]);

    return null;
}

function BundleGate({ children }: { children: React.ReactNode }) {
    const [, isBundleLoading] = useBundle(BUNDLE_NAME);

    if (isBundleLoading) {
        return null;
    }

    return <>{children}</>;
}

class App extends React.Component {
    render() {
        return (
            <BrowserRouter>
                <LocaleController />
                <BundleGate>
                    <Routes>
                        <Route path="/signup" element={<SignupPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/changePassword" element={<ChangePasswordPage />} />
                        <Route path="/error" element={<ErrorPage />} />
                        <Route path="*" element={<ErrorPage code="404" />} />
                    </Routes>
                </BundleGate>
            </BrowserRouter>
        );
    }
}

export default App;
